import { render, staticRenderFns } from "./AyudaYa.vue?vue&type=template&id=f800edaa"
import script from "./AyudaYa.vue?vue&type=script&lang=js"
export * from "./AyudaYa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports